import styles from './menu.module.scss';

const MenuItem = ({ label, href, onClick, active }) => {
	return (
		<a
			href={href}
			className={`${styles.menuItem} ${active ? styles.active : ''}`}
			onClick={onClick}
		>
			{label}
		</a>
	);
};

export default MenuItem;
